import { useEffect } from 'react';

import env from '../utils/env';

let envDisplayed = false;

const useEnv = () => {
    useEffect(() => {
        if (!envDisplayed) {
            envDisplayed = true;
        }
    }, []);

    return {
        ...env,
    };
};

export default useEnv;
